/**
 * @author Daniel Aguirre
 * @file constants.js
 * @description Appointments Constants
 */

// Generic actions
export const SCHEDULE_APPOINTMENT_ZOOM =
  'Appointments/SCHEDULE_APPOINTMENT_ZOOM';

export const CANCEL_APPOINTMENT_ZOOM = 'Appointments/CANCEL_APPOINTMENT_ZOOM';

export const RESCHEDULE_APPOINTMENT_ZOOM =
  'Appointments/RESCHEDULE_APPOINTMENT_ZOOM';

export const GET_ZOOM_VIDEO_CALL_BY_ID =
  'Appointments/GET_ZOOM_VIDEO_CALL_BY_ID';

export const GET_MULTIPLE_ZOOM_VIDEO_CALL_BY_ID =
  'Appointments/GET_MULTIPLE_ZOOM_VIDEO_CALL_BY_ID';
